import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import Swal from 'sweetalert2';

declare var $: any;
declare var bootstrap: any;
@Component({
  selector: 'app-site-headers',
  standalone: true,
  imports: [CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    RouterLink],
  templateUrl: './site-headers.component.html',
  styleUrl: './site-headers.component.scss'
})
export class SiteHeadersComponent {
  mobileMenuActive: boolean = false
  currentRoute: string = "";
  isActiveUrl: boolean = false;
  roleID: any;
  branch: any;
  mobile: any;
  single_admin_data: any;
  adminresetForm!: FormGroup;
  submitted: boolean = false;
  settingsDropdownOpen: boolean = false;
  goldDropdownOpen: boolean = false;

  constructor(private auth: AuthService,
    private router: Router,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,private eRef: ElementRef
  ) {
    this.currentRoute = this.router.url;
  }

  ngOnInit(): void {

    this.roleID = Number(localStorage.getItem('role_id'));
    this.mobile = localStorage.getItem("mobile");
    this.branch = (localStorage.getItem('branch') === 'undefined' || !localStorage.getItem('branch'))
      ? 'SuperAdmin'
      : localStorage.getItem('branch');



    this.adminresetForm = this.formBuilder.group({
      password: [
        "",
        [Validators.required, Validators.pattern(/^\S(?:[\s\S]*\S)?$/)],
      ],
      confirm_password: [
        "",
        [Validators.required, Validators.pattern(/^\S(?:[\s\S]*\S)?$/)],
      ],
    }, {
      validator: this.passwordMatchValidator('password', 'confirm_password')
    });
  }

  // logout() {
  //   var that = this;
  //   Swal.fire({
  //     title: "Are You Sure You Want To Logout?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "OK",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       that.auth.logout();
  //       that.router.navigate(["/login"]);
  //     } else if (result.isDenied) {
  //       Swal.fire("Changes are not saved", "", "info");
  //     }
  //   });
  // }
  logout() {
    if (!document.getElementById('customBackdropStyle')) {
      const style = document.createElement('style');
      style.id = 'customBackdropStyle';
      style.innerHTML = `
        .custom-backdrop {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background-color: rgba(0, 0, 0, 0.7); 
          z-index: 1050; 
        }
      `;
      document.head.appendChild(style);
    }

    let modal = new bootstrap.Modal(document.getElementById('logoutModal'), {
      backdrop: false,
      keyboard: false
    });

    modal.show();

    let backdrop = document.createElement('div');
    backdrop.className = 'custom-backdrop';
    backdrop.id = 'customBackdrop';
    document.body.appendChild(backdrop);

    document.getElementById('logoutModal')?.addEventListener('hidden.bs.modal', () => {
      let existingBackdrop = document.getElementById('customBackdrop');
      if (existingBackdrop) {
        existingBackdrop.remove();
      }
    });
  }

  confirmLogout() {
    let existingBackdrop = document.getElementById('customBackdrop');
    if (existingBackdrop) {
      existingBackdrop.remove();
    }
    this.auth.logout();
    this.router.navigate(['/login']);
  }


  hamClick() {
    this.mobileMenuActive = !this.mobileMenuActive
  }

  isActive(route: string): boolean {
    return this.currentRoute.includes(route);
  }

  toggleActive(active: boolean): void {
    this.isActiveUrl = active;
  }

  adminResetpassword() {
    this.submitted = true;

    let newPassword = this.adminresetForm.get('password');
    let confirmPassword = this.adminresetForm.get('confirm_password');
    if (
      newPassword &&
      confirmPassword &&
      newPassword.value !== confirmPassword.value
    ) {
      this.toastr.error('Password do not match.. Please Enter Valid Password');
      return;
    }

    if (this.adminresetForm.invalid) {
      this.toastr.error("Please Enter All The Required Fields..!");
      return false;
    }

    this.spinner.show();
    this.auth
      .resetAdminPassword(
        this.p['password'].value,
      )
      .subscribe({
        next: (data) => {
          if (data.status.code == 200) {
            this.spinner.hide();
            this.toastr.success(data.status && data.status.message);
            this.adminresetForm.reset();
            this.single_admin_data = {}
            this.submitted = false;
            $(".category_dropdown").hide();
            $("#myModal").modal("hide");
            this.ngOnInit();
          } else {
            this.toastr.error(data.status.message);
          }
        },
        error: (error) => {
          this.toastr.error(error.status && error.status.message);
          this.submitted = false;
        },
      });

    return true;
  }

  togglegoldDropdownOpen() {
    this.goldDropdownOpen = !this.goldDropdownOpen;
    this.settingsDropdownOpen = false;
  }

  toggleSettingsDropdown() {
    this.settingsDropdownOpen = !this.settingsDropdownOpen;
    this.goldDropdownOpen = false;
  }

  resetpass() {
    this.resetModal();
    $("#myModal").modal({
      backdrop: 'static',
      keyboard: false
    }).modal('show');

  }
  passwordMatchValidator(passwordControl: string, confirmPasswordControl: string): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const password = group.get(passwordControl)?.value;
      const confirmPassword = group.get(confirmPasswordControl)?.value;

      return password === confirmPassword ? null : { 'passwordMismatch': true };
    };
  }

  get p() {
    return this.adminresetForm.controls;
  }

  resetModal() {
    this.submitted = false;
    this.adminresetForm.reset();
    $("#myModal").modal('hide');
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.goldDropdownOpen = false;
      this.settingsDropdownOpen = false;
    }
  }
}
